export const redirectToLogin = (isUserCenter: any) => {
  const { origin, href } = window.location;
  // 这个地址不能随便改，要找vince.huang加白名单。
  // 目前只支持https://solix-sit.anker-in.com和 http://localhost:8000
  const loginCallback = `${origin}${API_BASE_PATH}/login&state=${origin}`;
  let ssoUrl = '';

  // 添加调试日志
  console.log('redirectToLogin - 环境调试信息:');
  console.log('origin:', origin);
  console.log('href:', href);
  console.log('API_BASE_PATH:', API_BASE_PATH);
  console.log('loginCallback:', loginCallback);
  console.log('APP_ROLE:', APP_ROLE);
  // if (isUserCenter) {
  //   let originMsg = '';
  //   if (APP_ROLE === 'installer') {
  //     originMsg = origin.includes('uat') ? `https://residential-uat.anker-in.com` : `https://residential.ankersolix.com`;
  //   } else {
  //     originMsg = `https://solix${origin.includes('uat') ? '-uat' : ''}.anker-in.com`;
  //   }
  //   console.log('originMsg111', originMsg);
  //   // ssoUrl = `https://bam-uat.anker-in.com:28443/idp/oauth2/authorize?client_id=solix&response_type=code&redirect_uri=${originMsg}/user-center/open/login&state=${originMsg}`; // sit
  //   ssoUrl = `https://bam-uat.anker-in.com:28443/idp/oauth2/authorize?client_id=solix&response_type=code&redirect_uri=${originMsg}/user-center/open/login&state=${href}`; // sit
  //   // ssoUrl = `https://bam-uat.anker-in.com:28443/idp/oauth2/authorize?client_id=solix&response_type=code&redirect_uri=https://solix-uat.anker-in.com/user-center/open/login`; // sit
  if (isUserCenter) {
    return;
  }
  // } else {
  if (APP_ROLE === 'installer') {
    // 安装商端
    let originMsg = '';
    if (origin.includes('https://residential.ankersolix.com')) {
      // prod
      originMsg = `https://buc.anker-in.com`;
    } else if (origin.includes('residential-uat.anker-in.com')) {
      // uat - 精确匹配UAT环境
      originMsg = `https://buc-uat.anker-in.com`;
    } else if (origin.includes('residential-sit.anker-in.com')) {
      // sit - 精确匹配SIT环境
      originMsg = `https://buc-sit.anker-in.com`;
    } else {
      // fallback - 如果都不匹配，默认为SIT
      console.warn('Unknown environment in redirectToLogin, defaulting to SIT:', origin);
      originMsg = `https://buc-sit.anker-in.com`;
    }
    ssoUrl = `${originMsg}/authorization/oauth2/authorize?client_id=anker-solix-installer-console&response_type=code&scope=openid&redirect_uri=${
      isUserCenter ? href : loginCallback
    }`;
  } else {
    // 管理端
    // ssoUrl = `https://open.anker-in.com/authorization/oauth2/authorize?client_id=anker-solix-installer-console&response_type=code&scope=openid&redirect_uri=${loginCallback}`;
    if (origin.includes('http://solix.anker-in.com')) {
      // prod
      ssoUrl = `https://iam.anker-in.com/idp/oauth2/authorize?client_id=solix&response_type=code&redirect_uri=${isUserCenter ? href : loginCallback}`; // uat
    } else if (origin.includes('uat')) {
      //uat
      ssoUrl = `https://bam-uat.anker-in.com:28443/idp/oauth2/authorize?client_id=solixuat&response_type=code&redirect_uri=${
        isUserCenter ? href : loginCallback
      }`; // uat
    } else {
      // sit
      ssoUrl = `https://bam-uat.anker-in.com:28443/idp/oauth2/authorize?client_id=solix&response_type=code&redirect_uri=${
        isUserCenter ? href : loginCallback
      }`; // sit
    }
  }
  // }
  // 页面跳转到sso登录页
  console.log('ssoUrl', ssoUrl);
  window.location.href = ssoUrl;
};
